import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

export const Title = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 180%;
    text-align: center;
    color: ${theme.colors.secondary};
  `}
`

export const Message = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    text-align: center;
    color: ${theme.colors.gray.dark};
  `}
`

export const WarningMessage = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    text-align: center;
    color: ${theme.colors.error.color};
  `}
`
